import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import PropTypes from 'prop-types'

import LocationSelector from '../LeftMenu/LocationSelector'
import { setActiveLocation } from '../../state/actions/account'
import './styles.css'

class TopMenu extends Component {
  static propTypes = {
    activeLocation: PropTypes.shape({
      active: PropTypes.bool.isRequired,
      additional_recipients: PropTypes.arrayOf(PropTypes.object),
      city: PropTypes.string,
      country_code: PropTypes.string,
      created_at: PropTypes.string,
      doctor_id: PropTypes.string,
      earliest_same_day_reminder_hour: PropTypes.number,
      facebook_url: PropTypes.string,
      forwarding_email: PropTypes.string,
      google_url: PropTypes.string,
      id: PropTypes.string,
      latitude: PropTypes.number,
      longitude: PropTypes.number,
      name: PropTypes.string,
      office_email: PropTypes.string,
      office_phone: PropTypes.string,
      phone_numbers: PropTypes.arrayOf(PropTypes.object),
      practice_id: PropTypes.number,
      state: PropTypes.string,
      street_address: PropTypes.string,
      timezone: PropTypes.string,
      updated_at: PropTypes.string,
      website: PropTypes.string,
      yelp_url: PropTypes.string,
      zip: PropTypes.string,
    }),
    dispatchSetActiveLocation: PropTypes.func.isRequired,
    locations: PropTypes.arrayOf(
      PropTypes.shape({
        active: PropTypes.bool.isRequired,
        additional_recipients: PropTypes.arrayOf(PropTypes.object),
        city: PropTypes.string,
        country_code: PropTypes.string,
        created_at: PropTypes.string,
        doctor_id: PropTypes.string,
        earliest_same_day_reminder_hour: PropTypes.number,
        facebook_url: PropTypes.string,
        forwarding_email: PropTypes.string,
        google_url: PropTypes.string,
        id: PropTypes.string,
        latitude: PropTypes.number,
        longitude: PropTypes.number,
        name: PropTypes.string,
        office_email: PropTypes.string,
        office_phone: PropTypes.string,
        phone_numbers: PropTypes.arrayOf(PropTypes.object),
        practice_id: PropTypes.number,
        state: PropTypes.string,
        street_address: PropTypes.string,
        timezone: PropTypes.string,
        updated_at: PropTypes.string,
        website: PropTypes.string,
        yelp_url: PropTypes.string,
        zip: PropTypes.string,
      }).isRequired,
      ),
  }

  selectLocation = (event, index, value) => {
    const { dispatchSetActiveLocation } = this.props
    dispatchSetActiveLocation(value)
  }

  render() {
    const {
      activeLocation,
      locations,
    } = this.props

    return (
      <div className="top-bar">
        <div className="top-bar-location">
          <div className="top-bar-title">Current Location:</div>
          <LocationSelector
            activeLocation={activeLocation}
            locations={locations}
            onChange={this.selectLocation}
          />
        </div>
      </div>
    )
  }
}

const mapStateToProps = ({
  account: {
    user: { activeLocation, locations },
  },
}) => ({
  activeLocation,
  locations,
})

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      dispatchSetActiveLocation: loc => dispatch(setActiveLocation(loc)),
    },
    dispatch,
  )

export default connect(mapStateToProps, mapDispatchToProps)(TopMenu)



// WEBPACK FOOTER //
// ./src/components/TopMenu/index.js